// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Loader{position:absolute;top:50%;left:50%;margin-right:-50%;transform:translate(-50%, -50%)}\n", ""]);
// Exports
module.exports = exports;
